import React, { FC } from 'react'
import { Divider, Text, csx } from '@vtex/admin-ui'

import {
  ProductContents,
  ProductInformationItemContents,
} from './ProductInformation'
import RightSideModal from '../RightSideModal'
import { useIntl } from '@/checkout-instore-legacy/hooks/intl'

type ProductInformationModalProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  aboutContents: ProductInformationItemContents
  title: string
}

const ProductInformationModal: FC<ProductInformationModalProps> = ({
  isOpen,
  setIsOpen,
  aboutContents,
  title,
}) => {
  const intl = useIntl()

  const renderInformation = () => {
    if (typeof aboutContents === 'string') {
      return (
        <div
          className={csx({
            flex: '1 1 auto',
            minWidth: 0,
            minHeight: 0,
            flexDirection: 'column',
            paddingTop: '1rem',
            marginLeft: '0.75rem',
          })}
          data-testid={`modal-contents-${title}`}
        >
          <Text
            dangerouslySetInnerHTML={{
              __html: aboutContents,
            }}
          />
        </div>
      )
    }

    return (
      <div
        className={csx({
          flex: '1 1 auto',
          minWidth: 0,
          minHeight: 0,
          flexDirection: 'column',
          paddingTop: '1rem',
          marginLeft: '.75rem',
        })}
        data-testid={`mmodal-contents-${title}`}
      >
        {aboutContents.map((item: ProductContents) => (
          <div key={item.name}>
            <div
              className={csx({
                paddingTop: '1rem',
                paddingBottom: '1rem',
              })}
            >
              <Text className={csx({ display: 'block' })}>{item.name}</Text>
              {item.values.map((specification: string) => {
                return (
                  <Text
                    variant="title1"
                    key={specification}
                    dangerouslySetInnerHTML={{ __html: specification }}
                    className={csx({ display: 'block' })}
                  />
                )
              })}
            </div>
            <Divider />
          </div>
        ))}
      </div>
    )
  }

  return (
    <RightSideModal
      title={intl.formatMessage({ id: title })}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      children={renderInformation()}
    />
  )
}

export default ProductInformationModal
